import React from "react";

import { EmptyStateContent } from "./EmptyStateContent";

export function NoDevices() {
    return <EmptyStateContent>No devices</EmptyStateContent>;
}
